module.exports = __webpack_public_path__ + "media/images/features/quote-screenshot-0cb0331791ace71831e2cce00371baea.png";